export const dlCouponCopiedEvent = (name) => {
    window.dataLayer.push({
        event: 'coupon_copied',
        coupon: {
            name
        }
    });
};
